// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"8cd66d4e","413":"76197b58","984":"40bd7afa"}[chunkId] + ".chunk.js";
};